module.exports = __webpack_public_path__ + "static/media/icon-back.6d7d0131.svg";